import React from 'react'
import BulkImport from './bulk-import'

const InstitutionSchoolsImportPage = () => {
  return (
    <div style={{ padding: '1em' }}>
      <BulkImport
        title='Import Schools & Colleges'
        uploadPath='admin/institutions/schools_import'
        templatePath='admin/institutions/schools_import/template'
      >
        Bulk-add Schools or Colleges to institutions by CSV.
        <ul>
          <li>Column <strong>Institution ID</strong>: the numeric institution ID (find it on the institution&apos;s edit page)</li>
          <li>Column <strong>School or College Name</strong>: the school or college name to add</li>
          <li>Rows are appended to each institution&apos;s existing list &mdash; a name that already exists for that institution (case-insensitive) is skipped, not duplicated</li>
        </ul>
      </BulkImport>
    </div>
  )
}

export default InstitutionSchoolsImportPage
